export const FLOOR_PLAN_VIEW_TABLET_BREAKPOINT = '(max-width: 1160px)';
